<template>
  <div class="a-step-group">
    <slot />
  </div>
</template>
<script lang="ts">
import {
  type ComponentPublicInstance,
  defineComponent,
  provide,
  reactive,
  toRefs
} from 'vue'
import { type DoActionType } from '../hooks'
import { stepGroupProps, stepGroupContextKey } from './step-group'

export default defineComponent({
  props: stepGroupProps,
  emits: [
    'update:modelValue',
    'change',
    'before-enter',
    'after-enter',
    'before-leave',
    'after-leave'
  ],
  setup (props, { emit, expose }) {
    const prevStep: Array<string | number> = []
    const children: ComponentPublicInstance[] = []

    const linkChildren = (child: ComponentPublicInstance) => {
      children.push(child)
    }

    const changeEvent = (name: string | number) => {
      emit('change', name)
    }

    const doAction = (action: DoActionType, value: string | number) => {
      emit(action, value)
    }

    provide(
      stepGroupContextKey,
      reactive({
        ...toRefs(props),
        link: linkChildren,
        changeEvent,
        doAction
      })
    )
    return {}
  }
})
</script>
<style lang="less">
.a-step-group {
  display: flex;
  flex-direction: column;
}
</style>
